export default "__VITE_ASSET__YvinsoYR__"